class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.handleBodyClick = this.handleBodyClick.bind(this);
    this.handleEscape = this.handleEscape.bind(this);

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code && event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  handleBodyClick(event) {
    if (!this.hasAttribute('open') && !this.classList.contains('active')) return;

    const drawerInner = this.querySelector('.drawer__inner');
    const clickedCartTrigger = event.target.closest(
      '#cart-icon-bubble, .header__icon--cart, [aria-controls="CartDrawer"], [data-cart-drawer-open]'
    );

    if (!drawerInner) return;
    if (drawerInner.contains(event.target)) return;
    if (clickedCartTrigger) return;

    this.close();
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role') && typeof this.setSummaryAccessibility === 'function') {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.setAttribute('open', '');

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('cart-drawer-open');

    document.addEventListener('click', this.handleBodyClick, true);
    document.addEventListener('keydown', this.handleEscape);
  }

  close() {
    this.classList.remove('active');
    this.removeAttribute('open');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer-open');

    document.removeEventListener('click', this.handleBodyClick, true);
    document.removeEventListener('keydown', this.handleEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) {
      inner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      const html = parsedState.sections[section.id];
      if (!html) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this));
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const target = doc.querySelector(selector);
    return target ? target.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}